// extracted by mini-css-extract-plugin
export default {"box":"Navbar_box__YAx4t","menulist":"Navbar_menulist__3218M","default":"Navbar_default__EArS5","active":"Navbar_active__zz1Pj","btn":"Navbar_btn__vmd9V"};